<template>
  <div class="">
    <div class="head-title">群素材</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、具有客户群使用权限的群主可在外部群聊中自行创建或选择已有的欢迎语素材，设置完成后，客户将在加入外部群聊后收到该欢迎语。<a
              class="help-link"
              href="http://www.weijub.com/index/index/news_detail?id=129"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
          <p>
            2、如果发送内容里需要展示客户的名称用%NICKNAME%代替，到时候客户入群会自动替换成客户的姓名。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="header-menu">
        <div class="menu-left">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建素材</el-button
          >
        </div>
        <div class="menu-right">
          <div class="menu-right-select">
            <el-select
              clearable
              class="menu-select"
              style="width: 27.0rem"
              v-model="msgType"
              placeholder="请选择"
              @change="changeType"
            >
              <el-option
                v-for="item in typeData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="menu-right-ipt" >
            <el-input
              clearable
              style="width: 35.0rem; "
              prefix-icon="el-icon-search"
              placeholder="请输入发送内容搜索"
              v-model="searchVal"
              @change="onSearch"
            >
            <el-button slot="append" type="primary" @click="onSearch"
              >查询</el-button
            >
            </el-input>

          </div>
        </div>
      </div>
      <div class="container">
        <el-table :data="tableData" v-loading="tableLoading" border >
          <el-table-column
            show-overflow-tooltip
            label="发送内容"
            prop="title"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="素材" prop="url">
            <template slot-scope="scope">
              <div
                v-if="
                  scope.row.type == '图片' ||
                  scope.row.type == '图文' ||
                  scope.row.type == '小程序'
                "
              >
                <el-image
                  style="width: 5.0rem; height: 5.0rem"
                  :src="scope.row.url"
                  :preview-src-list="[scope.row.url]"
                  fit="scale-down"
                ></el-image>
              </div>
              <div v-if="scope.row.type == '视频'">
                <video
                  style="width: 20.0rem; height: 11.2rem"
                  :src="scope.row.url"
                  controls="controls"
                ></video>
              </div>
              <div v-if="scope.row.type == '文件'">
                {{ scope.row.file_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="素材类型"
            prop="type"
            width="120"
          ></el-table-column>
          <el-table-column prop="createtime" label="创建时间" width="240">
            <template slot-scope="scope">
              <span style="margin-left: 1.0rem">{{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"  fixed="right" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.$index, scope.row)"
                style="color:#f00000 !important"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            @pagination="getData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";

export default {
  name: "mine",
  components: {
    pagination,
  },
  data() {
    return {
      typeData: [
        {
          value: "",
          label: "请选择类型",
        },
        {
          value: "文本",
          label: "文本",
        },
        {
          value: "图片",
          label: "图片",
        },
        {
          value: "视频",
          label: "视频",
        },
        {
          value: "文件",
          label: "文件",
        },
        {
          value: "图文",
          label: "图文",
        },
      ],
      msgType: "",
      searchVal: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      content: "",
      title: "",
      tableLoading: true,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getData();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    getData() {
      this.axios
        .post(
          "/crm/GroupMaterial/getMaterial",
          qs.stringify({
            examineCode: this.tooken.examineCode,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            type: this.msgType,
            title: this.searchVal,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    onAdd() {
      this.$router.push({
        name: "materialAdminDetailGroup",
      });
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "materialAdminDetailGroup",
        query: {
          id: row.id,
          template_id: row.template_id,
        },
      });
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该条数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/GroupMaterial/delMaterial",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                template_id: row.template_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.tableData = [];
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeType() {
      this.getData();
    },
    onSearch() {
      this.getData();
    },
    copyUrl() {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute(
        "value",
        `${location.origin}/#/sendchat?account_id=${this.tooken.account_id}&examineCode=${this.tooken.examineCode}&phone=${this.tooken.phone}`
      );
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功");
      }
      document.body.removeChild(input);
    },
  },
};
</script>
<style  scoped>
.materialAdmin {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}
.header-menu {
  margin: 1.0rem 0 2.0rem 0;
  display: flex;
  justify-content: space-between;
}
.menu-right {
  display: inline-flex;
}
.menu-select {
  margin-right: 1.6rem;
}
.paging {
  margin-top: 2.0rem;
}
.header-menu .menu-left .copy-url {
  margin-left: 2.4rem;
}
.el-button--text{padding-left:0rem !important;}
</style>
